module.exports = __webpack_public_path__ + "img/img-main-璟馨.712fb8d3.png";